import { render, staticRenderFns } from "./ShowTranfer.vue?vue&type=template&id=af519be6&scoped=true&"
import script from "./ShowTranfer.vue?vue&type=script&lang=js&"
export * from "./ShowTranfer.vue?vue&type=script&lang=js&"
import style0 from "./ShowTranfer.vue?vue&type=style&index=0&id=af519be6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af519be6",
  null
  
)

export default component.exports